import { Grid, TextField, Typography } from '@material-ui/core'
import React from 'react'
import makeStyles from "@material-ui/core/styles/makeStyles";


const useStyles = makeStyles(() => ({
    numberField: {
        width: '47px'
    },
    fakeField: {
        width: '100%',
        minHeight: '40px',
        padding: '7px 14px',
        borderColor: 'rgba(0, 0, 0, 0.23)',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: '4px',
        '&:hover': {
            borderColor: 'rgba(0, 0, 0, 0.87)',
            cursor: 'pointer'
        }
    },

}))

export const FakeFieldTemplateScheme = ({
    label,
    widthFieldXs,
    ...fieldProps
}) => {

    const classes = useStyles()
    return (
        <Grid item xs={widthFieldXs == 0 ? 12 : widthFieldXs}>
            <div className={classes.fakeField}>
                <Typography 
                    variant={'body1'}
                >
                    {label.slice(0, 50)}
                </Typography>
            </div>       
        </Grid>

    )
}
